// Контент для КПТ-дневника: 10 эмоций, 10 искажений, 3 практики на эмоцию.
// Совпадает с backend/app/Support/CbtContent.php — slug одинаковые.

export interface Emotion {
  slug: string;
  label: string;
  emoji: string;
  color: string;
}

export const EMOTIONS: Emotion[] = [
  { slug: 'anxiety', label: 'Тревога', emoji: '😟', color: '#F59E0B' },
  { slug: 'sadness', label: 'Грусть', emoji: '😢', color: '#6366F1' },
  { slug: 'anger', label: 'Гнев', emoji: '😡', color: '#DC2626' },
  { slug: 'fear', label: 'Страх', emoji: '😨', color: '#7C3AED' },
  { slug: 'guilt', label: 'Вина', emoji: '😔', color: '#0891B2' },
  { slug: 'shame', label: 'Стыд', emoji: '😳', color: '#DB2777' },
  { slug: 'irritation', label: 'Раздражение', emoji: '😤', color: '#EA580C' },
  { slug: 'loneliness', label: 'Одиночество', emoji: '🥺', color: '#475569' },
  { slug: 'joy', label: 'Радость', emoji: '😊', color: '#16A34A' },
  { slug: 'confusion', label: 'Растерянность', emoji: '🤔', color: '#9333EA' },
];

export const getEmotion = (slug: string): Emotion | undefined =>
  EMOTIONS.find((e) => e.slug === slug);

export interface Distortion {
  slug: string;
  label: string;
  emoji: string;
  description: string;
}

export const DISTORTIONS: Distortion[] = [
  {
    slug: 'catastrophizing',
    label: 'Катастрофизация',
    emoji: '🌪️',
    description: 'Мысль превращает любую неприятность в катастрофу: «всё пропало», «жизнь кончена».',
  },
  {
    slug: 'black_white',
    label: 'Чёрно-белое мышление',
    emoji: '⚫⚪',
    description: 'Только два варианта: либо успех, либо провал. Никаких оттенков и середины.',
  },
  {
    slug: 'mind_reading',
    label: 'Чтение мыслей',
    emoji: '🔮',
    description: 'Уверенность, что точно знаешь что думают другие — без доказательств.',
  },
  {
    slug: 'overgeneralization',
    label: 'Сверхобобщение',
    emoji: '♾️',
    description: 'Один случай распространяется на всё: «у меня всегда так», «никто никогда».',
  },
  {
    slug: 'personalization',
    label: 'Персонализация',
    emoji: '🪞',
    description: 'Приписываешь себе ответственность за то, на что мало влияешь или вообще не влияешь.',
  },
  {
    slug: 'negative_filter',
    label: 'Негативная фильтрация',
    emoji: '🔍',
    description: 'Замечаешь только плохое, хорошее не учитываешь.',
  },
  {
    slug: 'should_statements',
    label: 'Долженствование',
    emoji: '📏',
    description: '«Я должен», «они обязаны» — жёсткие правила, нарушение которых ведёт к вине или гневу.',
  },
  {
    slug: 'emotional_reasoning',
    label: 'Эмоциональное мышление',
    emoji: '💭',
    description: '«Я чувствую — значит это правда»: тревога превращается в доказательство опасности.',
  },
  {
    slug: 'magnification',
    label: 'Преувеличение',
    emoji: '🔎',
    description: 'Раздуваешь проблему до огромных размеров — она становится больше, чем есть.',
  },
  {
    slug: 'discounting_positive',
    label: 'Обесценивание позитива',
    emoji: '🚫',
    description: '«Это не считается», «повезло случайно» — хорошее объясняешь чем-то внешним.',
  },
];

export const getDistortion = (slug: string): Distortion | undefined =>
  DISTORTIONS.find((d) => d.slug === slug);

export interface Practice {
  slug: string;
  title: string;
  description: string;
}

export const REFRAME_HINTS = [
  'Какие факты подтверждают эту мысль, а какие — противоречат?',
  'Что бы ты сказал другу, который бы оказался в такой же ситуации?',
  'Какая мысль будет более полезной и точной?',
  'Что самое страшное может случиться — и сколько шансов, что это случится?',
  'Какие у меня есть ресурсы, чтобы справиться, если что?',
];

export const HOW_IT_WORKS_STEPS = [
  {
    emoji: '👀',
    title: 'Фиксируй',
    description: 'Заметь эмоцию, оцени силу, опиши что происходило в теле и в ситуации.',
  },
  {
    emoji: '🧠',
    title: 'Анализируй',
    description: 'Запиши автоматическую мысль — то, что появилось в голове первым.',
  },
  {
    emoji: '🎯',
    title: 'Находи',
    description: 'Распознай когнитивные искажения — где мысль перекрутила реальность.',
  },
  {
    emoji: '🌱',
    title: 'Меняй',
    description: 'Сформулируй более взвешенный взгляд и проверь, как изменилась эмоция.',
  },
];
